
import { Component, Prop } from 'vue-property-decorator';
import breakpointState from '@/core/responsive/breakpointsState.observable';
import { XS } from '@/core/config/breakpointConfig';
import BaseBlock from './BaseBlock.vue';

@Component({
    components: { BaseBlock }
})
export default class AspectRatioBlockContainer extends BaseBlock {
	@Prop({
	    required: false,
	    type: Number,
	    default: 50
	})
	widthOnScreen!: number;

	@Prop({
	    required: false,
	    type: Number,
	    default: 3
	})
	aspectRatio!: number;

	protected get isMobile() {
	    return breakpointState.isBreakpointActive(XS);
	}

	protected get realWidthOnScreen(): number {
	    // For mobile, width is controlled from within.
	    return this.isMobile ? 100 : this.widthOnScreen;
	}

	protected get aspectRatioStyling() {
	    return {
	        paddingBottom: (1 / this.aspectRatio) * 100 + '%'
	    };
	}
}
